var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3, _react_refresh_temp_4;
/**
 * This is the list of privileges that should be used for checking if the member
 * is privileged enough to do certain action.
 */
const Privilege = {
    WORKSPACE_CRUD: 'workspaceCrud',
    WORKSPACE_DOMAIN: 'workspaceDomain',
    WORKSPACE_MFA: 'workspaceMfa',
    WORKSPACE_AUDIT_CONFIG: 'workspaceAuditConfig',
    MEMBERS_READ: 'membersRead',
    MEMBERS_ORG_INVITE: 'membersOrgInvite',
    MEMBERS_INDIVIDUAL_INVITE: 'membersIndividualInvite',
    MEMBERS_UPDATE: 'membersUpdate',
    MEMBERS_DELETE: 'membersDelete',
    MEMBERS_REQUEST_DELETE: 'membersRequestDelete',
    MEMBERS_ROLE: 'membersRole',
    MEMBERS_STATUS: 'membersStatus',
    GROUPS_READ: 'groupsRead',
    GROUPS_CREATE: 'groupsCreate',
    GROUPS_UPDATE: 'groupsUpdate',
    GROUPS_DELETE: 'groupsDelete',
    GROUP_MEMBERSHIPS: 'groupMemberships',
    BILLING: 'billing',
    SSO: 'sso',
    CAN_ADMIN_FILESPACES: 'canAdminFilespaces',
    FILESPACE_CRUD: 'filespaceCrud',
    MIGRATION: 'migration',
    ONBOARDING: 'onboarding',
    SERVICE_ACCOUNT_CRUD: 'serviceAccountCrud',
    SERVICE_COLLABORATOR_CRUD: 'serviceCollaboratorCrud',
};
export const PRIVILEGES = Object.values(Privilege);
_react_refresh_temp_1 = PRIVILEGES;
$RefreshReg$(_react_refresh_temp_1, "PRIVILEGES");
/**
 * This is the list of privileges that should be used only on the WebService side.
 */
const InternalPrivilege = {
    ADMIN_KEY: 'adminKey',
    ADMIN_ALL_FILESPACES: 'adminAllFilespaces',
    EVERYONE: 'everyone',
    SKIP_CODE_VERIFICATION: 'skipCodeVerification',
};
export const INTERNAL_PRIVILEGES = Object.values(InternalPrivilege);
_react_refresh_temp_2 = INTERNAL_PRIVILEGES;
$RefreshReg$(_react_refresh_temp_2, "INTERNAL_PRIVILEGES");
/**
 * This is the list of privileges that can be expanded to simpler privileges.
 * Expansion rules can be found in expand-privileges.ts
 */
const CompoundPrivilege = {
    MEMBERS: 'members',
    GROUPS: 'groups',
    MEMBERS_AND_GROUPS: 'membersAndGroups',
};
const COMPOUND_PRIVILEGES = Object.values(CompoundPrivilege);
_react_refresh_temp_3 = COMPOUND_PRIVILEGES;
$RefreshReg$(_react_refresh_temp_3, "COMPOUND_PRIVILEGES");
export const isCompoundPrivilege = (privilege) => {
    return COMPOUND_PRIVILEGES.includes(privilege);
};
/**
 * This is a list of deprecated privileges we should start removing them at some
 * point.
 * Mark every deprecated privilege with js-doc comment that says why it was
 * deprecated and what should you use instead if anything. Also include the
 * date that deprecation was made so we can make a design on when to remove it.
 */
const DeprecatedPrivilege = {
    /**
     * @deprecated
     * The privilege was deprecated in favor of `membersRole` for the purpose
     * of consistency with the newly introduced `membersRead`, `membersRole`, etc.
     *
     * Use: `membersRole`
     *
     * Date: 2025-08-05
     */
    MEMBER_ROLES: 'memberRoles',
};
/**
 * AllPrivileges should contain everything those are used for serialization and
 * expansion results assuring backward compatibility
 */
export const AllPrivilege = {
    ...CompoundPrivilege,
    ...InternalPrivilege,
    ...DeprecatedPrivilege,
    ...Privilege,
};
export const ALL_PRIVILEGES = Object.values(AllPrivilege);
_react_refresh_temp_4 = ALL_PRIVILEGES;
$RefreshReg$(_react_refresh_temp_4, "ALL_PRIVILEGES");
